import * as React from 'react';
import styled from 'styled-components';

import { COLORS, hexWithOpacity } from 'styles/style-constants';

const SwitchContainer = styled.button<{ $checked: boolean }>`
    position: relative;
    width: 4.2rem;
    height: 2.4rem;
    min-width: 4.2rem;
    padding: 0;
    border: none;
    border-radius: 2.4rem;
    background: ${({ $checked }) => ($checked ? COLORS.purple500 : COLORS.gray100)};
    cursor: pointer;
    transition: background 0.2s ease;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    &:hover:not(:disabled) {
        background: ${({ $checked }) => ($checked ? COLORS.purple400 : COLORS.gray200)};
    }
`;

const SwitchKnob = styled.div<{ $checked: boolean }>`
    position: absolute;
    top: 0.3rem;
    left: ${({ $checked }) => ($checked ? '2.1rem' : '0.3rem')};
    width: 1.8rem;
    height: 1.8rem;
    border-radius: 50%;
    background: ${COLORS.white};
    box-shadow: 0 0.1rem 0.2rem ${hexWithOpacity(COLORS.black, 15)};
    transition: left 0.2s ease;
`;

interface ToggleSwitchProps {
    checked: boolean;
    onChange: (value: boolean) => void;
    disabled?: boolean;
}

const ToggleSwitch = ({ checked, onChange, disabled, ...props }: ToggleSwitchProps) => (
    <SwitchContainer
        type="button"
        role="switch"
        aria-checked={checked}
        $checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        {...props}
    >
        <SwitchKnob $checked={checked} />
    </SwitchContainer>
);

export default ToggleSwitch;
